module.exports = __webpack_public_path__ + "img/tit1.081cb8d0.svg";